module.exports = __webpack_public_path__ + "img/icon_award-02.f74dcaae.svg";